/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-07 09:32:36
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-06-13 16:48:59
 */
export default {
    sex :{
        1:'男',
        2:'女',
        0:'未知'
    },
    relation:{
        1:'本人',
        2:'父母',
        3:'子女',
        4:'配偶',
        5:'亲属',
        6:'朋友',
        7:'其他',
    },
    relationColumns:[
        {text:'本人', value:1,},
        {text:'父母', value:2,},
        {text:'子女', value:3,},
        {text:'配偶', value:4,},
        {text:'亲属', value:5,},
        {text:'朋友', value:6,},
        {text:'其他', value:7,},
    ],
    grade:{
       '三级甲等':'三甲' ,
       '三级特等':'三特' ,
       '三级乙等':'三乙' ,
       '三级丙等':'三丙' ,
    //    '三级医院':'三级' ,
       '二级甲等':'二甲' ,
    //    '二级乙等':'二乙' ,
    //    '二级丙等':'二丙' ,
    //    '二级医院':'二级' ,
    //    '一级甲等':'一甲' ,
    //    '一级乙等':'一乙' ,
    //    '一级丙等':'一丙' ,
    //    '一级医院':'一级' ,
    //    '未知医院':'未知' ,
    },
    consultStatus:{
        1:'进行中',
        2:'未选择就诊人',
        3:'待接诊',
        4:'已完成',
        5:'已取消'
    },
    orderStatus: {
        1: '待支付',
        2: '进行中',
        3: '交易成功',
        4: '交易关闭'
    },
    refundStatus: {
        // 1: '退款中',
        // 2: '人工取消',
        // 3: '系统退款',
        // 4: '人工退款',
        // 5: '退款失败',
        // 6: '超时取消'
        '4':'患者取消',
        '3':'超时取消',
        '5':'系统取消',
        '7':'商品退回中',
        '1':'退款中',
        '2':'全部退款成功',
        '8':'部分退款成功',
        '6':'退款失败',
        '9':'拒绝退款',
        '10':'商品退回中',
    },
    // 药品订单状态	11-待流转 12-待确认 13-待发货 14-已发货 15-已签收 21-待使用 22-已使用 99-交易关闭
    drugsOrderStatus: {
        0:'待支付',
        11:'待发货',
        6:'待发货',
        12:'待发货',
        13:'待发货',
        14:'待签收',
        15:'交易成功',
        21:'待使用',
        22:'已使用',
        25:'待发货',
        99:'交易关闭'
    },
    // 服务包订单状态
    aggOrderStatus: {
        0:'待支付',
        1:'待发货',
        2:'部分发货',
        3:'待签收',
        4:'交易成功',
        5:'交易关闭',
        6:'药师审核'
    },
    //服务包退款状态
    aggRefundStatus:{
        // 1:'退款中',
        // 2:'退款成功',
        // 3:'超时取消',
        '4':'患者取消',
        '3':'超时取消',
        '5':'服务包下架',
        '7':'商品退回中',
        '1':'退款中',
        '2':'全部退款成功',
        '8':'部分退款成功',
        '6':'退款失败',
        '9':'拒绝退款',
        '10':'商品退回中',
    },
    //子订单状态
    sonOrderDetailStatus:{
        0:'待支付',
        11:'待发货',
        12:'待发货',
        13:'待发货',
        14:'待签收',
        15:'已签收',
        21:'待使用',
        22:'已使用',
        99:'交易关闭'
    },
    planStatus:{
        0:'未开始',
        1:'进行中',
        2:'已结束',
        3:'已停止',
    },
    serviceOrderGroupStatus:{
        1:'未购买',
        2:'进行中',
        3:'已完成',
        4:'已结束',
        5:'已取消',
        99:'已取消'
    },
    refundType:{
        1:'退款',
        2:'退货退款'
    },
    // 投保状态:0.未投保1.投保中 2.审核中 3.投保成功 4.投保失败 5.放弃投保 6.已失效
    insureStatus:{
        0:'待投保',
        1:'投保中',
        2:'审核中',
        3:'投保成功',
        4:'投保失败',
        5:'放弃投保',
        6:'已失效',
    },
    prescriptionStatus: {
        0: '审核中',
        1: '未通过',
        2: '未使用',
        3: '已使用',
        4: '已关闭',
        5: '已失效',
    },
    invoiceStatus:{0:'未申请',1:'已申请',2:'部分开具',3:'已开具'},
    conponType:{
        1:'直减劵'
    },
    // 指标状态
    bloodStatus: {
        '正常': 'normal',
        '偏高': 'high',
        '偏低': 'low'
    },
    bloodStatusStr: {
        normal: '正常',
        high: '偏高',
        low: '偏低'
    },
    indicatorType:{
        'height':'基本信息',
        'weight':'基本信息',
        'bloodPressure':'血压',
        'bloodSugar':'血糖',
        'hemoglobin':'糖化血红蛋白',
        'temperature':'体温',
        'bloodFat':'血脂',
        'gad7AnxietyScreening':'GAD-7焦虑症筛查',
    },
    indicatorUnit:{
        'height':'kg',
        'weight':'kg',
        'bloodPressure':'mmHg',
        'bloodSugar':'mmol/L',
        'hemoglobin':'g/L‌',
        'temperature':'℃',
        'bloodFat':'mmol/L'
    }
}



// WEBPACK FOOTER //
// ./src/utils/status.js